﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as CryptoJS from 'crypto-js';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MatDialog, MatTable } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import * as moment from 'moment-timezone';
import { Location } from '@angular/common';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptEntityComponent } from '../../../../_helpers/Modals/prompt-entity/modal.prompt-entity';

export interface Element {
  details: string;
  position: number;
  existing_detail: string;
  existing_details: string;
}

export interface PeriodicElementfile {
  doctype: string;
  olddoc: string;
  newdoc: string;

  filename: any;
  newfilename: any;
  filetype: any;
  fileExists: any;
  fileExists1: any;
}

export interface rejectlist {
  value: string;
  viewValue: string;
}

export interface modiflist {
  value: string;
  viewValue: string;
}
export interface selectedCountry {
  id: string;
  name: string;
}

export interface selectedState {
  id: string;
  name: string;
  country_id: string
}
export interface selectedCity {
  id: string;
  name: string;
  state_id: string;
}






@Component({
  selector: 'app-entity-verification',
  templateUrl: './entity-verification.component.html',
  styleUrls: ['./entity-verification.component.css']
})
export class EntityVerificationComponent implements OnInit {
  ELEMENT_DATA: Element[] = [
    { position: 1, details: 'Entity ID', existing_detail: '', existing_details: '' },
    { position: 2, details: 'Creator', existing_detail: '', existing_details: '' },
    { position: 3, details: 'Entity Classification', existing_detail: '', existing_details: '' },
    { position: 4, details: 'TM Type', existing_detail: '', existing_details: '' },
    { position: 5, details: 'POI Document Type', existing_detail: '', existing_details: '' },
    { position: 6, details: 'POI', existing_detail: '', existing_details: '' },
    { position: 7, details: 'GST ID', existing_detail: '', existing_details: '' },
    { position: 8, details: 'Full Address', existing_detail: '', existing_details: '' },
    { position: 9, details: 'Registered Address 1', existing_detail: '', existing_details: '' },
    { position: 10, details: 'Registered Address 2', existing_detail: '', existing_details: '' },
    { position: 11, details: 'Landmark', existing_detail: '', existing_details: '' },
    { position: 12, details: 'Country', existing_detail: '', existing_details: '' },
    { position: 13, details: 'State', existing_detail: '', existing_details: '' },
    { position: 14, details: 'City', existing_detail: '', existing_details: '' },
    { position: 15, details: 'PIN Code', existing_detail: '', existing_details: '' },

    { position: 16, details: 'Organization Name', existing_detail: '', existing_details: '' },
    { position: 17, details: 'Industry Category', existing_detail: '', existing_details: '' },
    { position: 18, details: 'Industry Type', existing_detail: '', existing_details: '' },
    { position: 19, details: 'Industry Sector', existing_detail: '', existing_details: '' },
    { position: 20, details: 'Authorized Signature Name', existing_detail: '', existing_details: '' },
    { position: 21, details: 'Registered Email ID', existing_detail: '', existing_details: '' },
    { position: 22, details: 'Registered Mobile Number', existing_detail: '', existing_details: '' },
    { position: 23, details: 'Status', existing_detail: '', existing_details: '' },
    { position: 24, details: 'CreateTS', existing_detail: '', existing_details: '' },
    { position: 25, details: 'ApprovedTs', existing_detail: '', existing_details: '' },
    { position: 26, details: 'UpdateTS', existing_detail: '', existing_details: '' },
    { position: 27, details: 'Service Provider', existing_detail: '', existing_details: '' },
    { position: 28, details: 'Blacklisted', existing_detail: '', existing_details: '' },
    { position: 29, details: 'POA Document Type', existing_detail: '', existing_details: '' },
    { position: 30, details: 'Other Document Name', existing_detail: '', existing_details: '' },
    { position: 31, details: 'Registration Status', existing_detail: '', existing_details: '' },
    { position: 32, details: 'Rejected Date', existing_detail: '', existing_details: '' },
    { position: 33, details: 'Modification Requested ON', existing_detail: '', existing_details: '' },

  ];

  ELEMENT_DATA_FILE: PeriodicElementfile[] = [
    { doctype: "POI", olddoc: "PAN Document", newdoc: "PAN Document", filename: '', newfilename: '', filetype: 'POI', fileExists: false, fileExists1: false },
    { doctype: "POA", olddoc: 'POA Document', newdoc: "POA Document", filename: '', newfilename: '', filetype: 'POA', fileExists: false, fileExists1: false },
    { doctype: "GST Certificate", olddoc: 'GST Certificate', newdoc: "GST Document", filename: '', newfilename: '', filetype: "GST", fileExists: false, fileExists1: false },
    { doctype: "SEBI Certificate", olddoc: 'SEBI Certificate', newdoc: "SEBI Document", filename: '', newfilename: '', filetype: "SEBI", fileExists: false, fileExists1: false },
    { doctype: "Other Document", olddoc: 'Other Document', newdoc: "Other Document", filename: '', newfilename: '', filetype: "OTHER", fileExists: false, fileExists1: false },
    { doctype: "Other Document2", olddoc: 'Other Document2', newdoc: "Other Document2", filename: '', newfilename: '', filetype: "OTHER1", fileExists: false, fileExists1: false },
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;
  entityRefNo: any;
  response: any;
  EntityStatus: any;
  disableForm: boolean;
  showRejectReason: boolean = false;
  showRemarks: boolean = false;
  showModifyReason: boolean = false;
  poi_type: any;
  reqStatus: any
  poa_type: any;
  poafilename: any;
  poifilename: any;
  approveFlag: boolean = false
  rejectFlag: boolean = false
  modifyFlag: boolean = false
  modifiedCount: any
  urnFormURL: any;
  Common_ID: any

  public modalRef: BsModalRef;
  returnedValue: any;


  constructor(private fb: FormBuilder,
    private modalService: BsModalService,
    //private es: APILoginService,
    private es: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private _location: Location,
    private router: Router) {
    // this.getEntityDetail();
    this.getEntityDetails();
    this._route.params.subscribe((params) => {
      this.urnFormURL = params['urn']
    })

  }//end of constructor

  displayedColumns: string[] = ['position', 'details', 'existing_detail', 'existing_details'];
  //dataSource1 = ELEMENT_DATA;
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  dataSource1 = new ExampleDataSource(this.ELEMENT_DATA);

  update(el: Element, comment: string) {
    if (comment == null) { return; }
    // copy and mutate
    const copy = this.dataSource1.data().slice()
    // el.request_modification = comment;
    this.dataSource1.update(copy);
  }

  displayedColumnsfile: string[] = ['doctype', 'olddoc', 'newdoc'];
  dataSourcefile = this.ELEMENT_DATA_FILE;

  rejectlistitems: rejectlist[] = [
    

  ];

  modiflistitems: modiflist[] = [
    { value: 'Address not complete in the Proof of Address shared', viewValue: 'Address not complete in the Proof of Address shared' },
    { value: 'Address on request different from the Address on the documents', viewValue: 'Address on request different from the Address on the documents' },
    { value: 'Documents have not been uploaded properly so could not be validated', viewValue: 'Documents have not been uploaded properly so could not be validated' },
    { value: 'Entity Name entered is different from name on the documents', viewValue: 'Entity Name entered is different from name on the documents' },
    { value: 'GST ID incorrect/ invalid/ not matching with the documents', viewValue: 'GST ID incorrect/ invalid/ not matching with the documents' },
    { value: 'GST certificate has not been uploaded', viewValue: 'GST certificate has not been uploaded' },
    { value: 'Incorrect  Industry type/ Sector selected', viewValue: 'Incorrect  Industry type/ Sector selected' },
    { value: 'Incorrect Industry Category selected (Govt/ PvtLtd/Public Ltd/ SEBI/ Others)', viewValue: 'Incorrect Industry Category selected (Govt/ PvtLtd/Public Ltd/ SEBI/ Others)' },
    { value: 'Incorrect PAN/ TAN Number entered', viewValue: 'Incorrect PAN/ TAN Number entered' },
    { value: 'Incorrect/ Incomplete details entered in the request', viewValue: 'Incorrect/ Incomplete details entered in the request' },
    { value: 'Insufficient / Invalid Documents uploaded', viewValue: 'Insufficient / Invalid Documents uploaded' },
    { value: 'Invalid / Expired documents uploaded', viewValue: 'Invalid / Expired documents uploaded' },
    { value: 'Invalid Pin Code entered', viewValue: 'Invalid Pin Code entered' },
    { value: 'Mismatch b/w information in the request and documents uploaded', viewValue: 'Mismatch b/w information in the request and documents uploaded' },
    { value: 'Mismatch in PAN/ TAN and Address b/w the request and documents', viewValue: 'Mismatch in PAN/ TAN and Address b/w the request and documents' },
    { value: 'PAN/ TAN Document has not been uploaded', viewValue: 'PAN/ TAN Document has not been uploaded' },
    { value: 'Proof of Address document has not been uploaded', viewValue: 'Proof of Address document has not been uploaded' },
    { value: 'Request cannot be raised by Individuals', viewValue: 'Request cannot be raised by Individuals' },
    { value: 'Reenter details of the TRUST in the request', viewValue: 'Reenter details of the TRUST in the request' },
    { value: 'SEBI certificate has not been attached', viewValue: 'SEBI certificate has not been attached' },
    { value: 'Unable to establish connection between PAN/TAN owner and entity', viewValue: 'Unable to establish connection between PAN/TAN owner and entity' },
   
  ];

  selectedCountrylist: selectedCountry[] = [
    { id: '1', name: 'India' }
  ];

  //states
  selectedStatelist: selectedState[] = [
    { id: '1', country_id: '1', name: 'Andhra Pradesh' },
    { id: '2', country_id: '1', name: 'Telagana' },
    { id: '3', country_id: '1', name: 'Karnataka' },
  ];

  selectedCitylist: selectedCity[] = [
    { id: '1', state_id: '1', name: 'Anantapur' },
    { id: '2', state_id: '1', name: 'Chittoor' },
    { id: '3', state_id: '2', name: 'Hyderabad' },
    { id: '4', state_id: '2', name: 'Kariminagar' },
    { id: '5', state_id: '3', name: 'Bengalore Urban  ' },
    { id: '6', state_id: '3', name: 'Bengalore Rural' }
  ];

  entityForm: FormGroup;
  selectedValue: String;
  name: string;
  position: number;
  weight: number;
  symbol: string;
  modiflist: any;
  rejectlist: any;

  get f() { return this.entityForm.controls; }

  ngOnInit() {
    this.entityForm = this.fb.group({
      request_type: [''],
      urn_no: [''],
      creation_timestamp: ['',],
      assigned_timestamp: ['',],
      paymen_applicable: ['',],
      remarks: ['', [Validators.required, Validators.maxLength(200), Validators.pattern('^(?! ).*(?<! )$')]], //, Validators.minLength(1)
      rej_reason: ['',],
      modification_reason: ['',],

    });//end of entityForm

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  } // oninit  

  getSubstring(newfilename) {
    if (newfilename)
      return newfilename.substring(newfilename.indexOf('.') + 1)
    else
      return
  }

  getEntityDetails() {
    var varEClass = {
      'G': 'Government',
      'P': 'Private Ltd Company',
      'S': 'SEBI',
      'U': 'Public Limited Company',
      'O1': 'Individual',
      'O2': 'Sole Proprietorship',
      'O3': 'Partnership Firm',
      'O4': 'Limited Liability Partnership',
      'O5': 'Trust, Association, Society, Club',
      'O': 'Others'
    }
    this._route.params.subscribe((params) => {
      this.entityRefNo = params['urn'];
    })
    this.es.getEntityDetailsUrn(this.entityRefNo)
      .subscribe(r => {
        this.response = r;
        console.log("getRegisteredDetails", r)

        this.ELEMENT_DATA_FILE[0]['filename'] = r.Previous_Data.Entity_POI_Doc
        this.ELEMENT_DATA_FILE[0]['newfilename'] = r.Entity_POI_Doc
        if (r.Previous_Data.Entity_POI_Doc)
          this.ELEMENT_DATA_FILE[0]['fileExists'] = true
        if (r.Entity_POI_Doc)
          this.ELEMENT_DATA_FILE[0]['fileExists1'] = true

        this.ELEMENT_DATA_FILE[1]['filename'] = r.Previous_Data.Entity_POA_Doc
        this.ELEMENT_DATA_FILE[1]['newfilename'] = r.Entity_POA_Doc
        if (r.Previous_Data.Entity_POA_Doc)
          this.ELEMENT_DATA_FILE[1]['fileExists'] = true
        if (r.Entity_POA_Doc)
          this.ELEMENT_DATA_FILE[1]['fileExists1'] = true

        this.ELEMENT_DATA_FILE[2]['filename'] = r.Previous_Data.Entity_GST_Doc
        this.ELEMENT_DATA_FILE[2]['newfilename'] = r.Entity_GST_Doc
        if (r.Previous_Data.Entity_GST_Doc)
          this.ELEMENT_DATA_FILE[2]['fileExists'] = true
        if (r.Entity_GST_Doc)
          this.ELEMENT_DATA_FILE[2]['fileExists1'] = true

        this.ELEMENT_DATA_FILE[3]['filename'] = r.Previous_Data.Entity_SEBI_Doc
        this.ELEMENT_DATA_FILE[3]['newfilename'] = r.Entity_SEBI_Doc
        if (r.Previous_Data.Entity_SEBI_Doc)
          this.ELEMENT_DATA_FILE[3]['fileExists'] = true
        if (r.Entity_SEBI_Doc)
          this.ELEMENT_DATA_FILE[3]['fileExists1'] = true

        this.ELEMENT_DATA_FILE[4]['filename'] = r.Previous_Data.Entity_Other_Doc
        this.ELEMENT_DATA_FILE[4]['newfilename'] = r.Entity_Other_Doc
        if (r.Previous_Data.Entity_Other_Doc)
          this.ELEMENT_DATA_FILE[4]['fileExists'] = true
        if (r.Entity_Other_Doc)
          this.ELEMENT_DATA_FILE[4]['fileExists1'] = true

        this.ELEMENT_DATA_FILE[5]['filename'] = r.Previous_Data.Entity_Other_Doc1
        this.ELEMENT_DATA_FILE[5]['newfilename'] = r.Entity_Other_Doc1
        if (r.Previous_Data.Entity_Other_Doc1)
          this.ELEMENT_DATA_FILE[5]['fileExists'] = true
        if (r.Entity_Other_Doc1)
          this.ELEMENT_DATA_FILE[5]['fileExists1'] = true

        if (r.message != "Not found" ) {
         // if (r.Previous_Data.Entity_POI_Doc != null || r.Previous_Data.Entity_POI_Doc != undefined) {
            this.reqStatus = r.Previous_Data.Entity_Status
            if (r.Previous_Data.Entity_Status == "C") {
              this.entityForm.controls['request_type'].setValue("New Registration");
            }
            else if (r.Previous_Data.Entity_Status == "R") {
              this.entityForm.controls['request_type'].setValue("Rejected")
            }
            else if (r.Previous_Data.Entity_Status == "M1") {
              this.entityForm.controls['request_type'].setValue("Sent For Modification, Modified Count: 1");
            }
            else if (r.Previous_Data.Entity_Status == "M2") {
              this.entityForm.controls['request_type'].setValue("Sent For Modification, Modified Count: 2");
            }
            else if (r.Previous_Data.Entity_Status == "A") {
              this.entityForm.controls['request_type'].setValue("Approved")
            }
            else {
              this.entityForm.controls['request_type'].setValue(" ");
            }
            var approvedTS = ''

            var rejectTS = ''
            if (r.Previous_Data.Entity_Status == "A")
              approvedTS = r.Previous_Data.E_Approve_Date + " " + r.E_Approve_Time

            else if (r.Previous_Data.Entity_Status == "R")
              rejectTS = r.Previous_Data.E_Approve_Date + " " + r.E_Approve_Time
            else {
              rejectTS = "";
              approvedTS = "";
            }

            this.ELEMENT_DATA[0]['existing_detail'] = r.Previous_Data.Entity_ID;
            if (r.Previous_Data.Entity_Creator != null)
              this.ELEMENT_DATA[1]['existing_detail'] = (r.Previous_Data.Entity_Creator).toUpperCase();
            this.ELEMENT_DATA[2]['existing_detail'] = r.Previous_Data.Entity_Registration_For
            if (r.Previous_Data.Entity_TM_Type != null && r.Previous_Data.Entity_TM_Type != "null")
              this.ELEMENT_DATA[3]['existing_detail'] = r.Previous_Data.Entity_TM_Type;
            this.ELEMENT_DATA[4]['existing_detail'] = r.Previous_Data.POI_Type;
            if (r.Previous_Data.POI != null)
              this.ELEMENT_DATA[5]['existing_detail'] = this.Pan(r.Previous_Data.POI);
            this.ELEMENT_DATA[6]['existing_detail'] = r.Previous_Data.Entity_GST_Id;

            if (r.Previous_Data.Entity_Addr != null)
              this.ELEMENT_DATA[7]['existing_detail'] = r.Previous_Data.Entity_Addr;

            this.ELEMENT_DATA[8]['existing_detail'] = r.Previous_Data.Entity_Addr1;
            this.ELEMENT_DATA[9]['existing_detail'] = r.Previous_Data.Entity_Addr2;

            if (r.Previous_Data.Entity_Landmark != null && r.Previous_Data.Entity_Landmark != "null")
              this.ELEMENT_DATA[10]['existing_detail'] = r.Previous_Data.Entity_Landmark;

            if (r.Previous_Data.Entity_Country != null && r.Previous_Data.Entity_Country != "null")
              this.ELEMENT_DATA[11]['existing_detail'] = r.Previous_Data.Entity_Country;
            if (r.Previous_Data.Entity_State != null && r.Previous_Data.Entity_State != "null")
              this.ELEMENT_DATA[12]['existing_detail'] = r.Previous_Data.Entity_State;

            if (r.Previous_Data.Entity_City != null && r.Previous_Data.Entity_City != "null")
              this.ELEMENT_DATA[13]['existing_detail'] = r.Previous_Data.Entity_City;
            this.ELEMENT_DATA[14]['existing_detail'] = r.Previous_Data.Entity_Pincode;
            this.ELEMENT_DATA[15]['existing_detail'] = r.Previous_Data.E_Org_Name;
            this.ELEMENT_DATA[16]['existing_detail'] = varEClass[r.Previous_Data.E_Org_Type];

            if (r.Previous_Data.Entity_Industry == "Others")
              this.ELEMENT_DATA[17]['existing_detail'] = "Others -" + r.Previous_Data.Entity_Industry_Other;
            else
              this.ELEMENT_DATA[17]['existing_detail'] = r.Previous_Data.Entity_Industry;

            if (r.Previous_Data.Entity_Sector == "Others")
              this.ELEMENT_DATA[18]['existing_detail'] = "Others -" + r.Previous_Data.Entity_Sector_Other;
            else
              this.ELEMENT_DATA[18]['existing_detail'] = r.Previous_Data.Entity_Sector;

            this.ELEMENT_DATA[19]['existing_detail'] = r.Previous_Data.Entity_AuthSignName;
            this.ELEMENT_DATA[20]['existing_detail'] = r.Previous_Data.Entity_EmailID;
            this.ELEMENT_DATA[21]['existing_detail'] = r.Previous_Data.Entity_Mobile_No;
            if (r.Previous_Data.Entity_Status == "C") {
              this.ELEMENT_DATA[22]['existing_detail'] = "Pending For Approval"
            } else if (r.Previous_Data.Entity_Status == "R") {
              this.ELEMENT_DATA[22]['existing_detail'] = "Pending For Approval"
            } else if (r.Previous_Data.Entity_Status == "M1") {
              this.ELEMENT_DATA[22]['existing_detail'] = "Sent For Modification, Modified Count: 1"
            } else if (r.Previous_Data.Entity_Status == "M2") {
              this.ELEMENT_DATA[22]['existing_detail'] = "Sent For Modification, Modified Count: 2"
            } else if (r.Previous_Data.Entity_Status == "A") {
              this.ELEMENT_DATA[22]['existing_detail'] = "Approved"
            } else {
              this.ELEMENT_DATA[22]['existing_detail'] = " "
            }
            this.ELEMENT_DATA[23]['existing_detail'] = moment(r.Previous_Data.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss')
            this.ELEMENT_DATA[24]['existing_detail'] = approvedTS;
            this.ELEMENT_DATA[25]['existing_detail'] = moment(r.Previous_Data.updatedAt).tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss')
            this.ELEMENT_DATA[26]['existing_detail'] = "Tata";
            this.ELEMENT_DATA[27]['existing_detail'] = "False"
            this.ELEMENT_DATA[28]['existing_detail'] = r.Previous_Data.POA;
            this.ELEMENT_DATA[29]['existing_detail'] = r.Previous_Data.Other_Doc_Name;
            if (r.Previous_Data.Entity_ID != "" && r.Previous_Data.Entity_ID != null) {
              this.ELEMENT_DATA[30]['existing_detail'] = "Registered"
            }
            else {
              this.ELEMENT_DATA[30]['existing_detail'] = "Not Registered"
            }
            this.ELEMENT_DATA[31]['existing_detail'] = rejectTS
            if (r.Previous_Data.E_Mod1_RequestAt != null && r.Previous_Data.E_Mod1_RequestAt != undefined)
              this.ELEMENT_DATA[32]['existing_detail'] = moment(r.Previous_Data.E_Mod1_RequestAt).tz('Asia/Kolkata').format('LLL');
            else
              this.ELEMENT_DATA[32]['existing_detail'] = ""
         // } else {
            // this.ELEMENT_DATA_FILE[0]['filename'] = "";
            // this.ELEMENT_DATA_FILE[0]['fileExists'] = false

            // this.ELEMENT_DATA_FILE[1]['filename'] = "";
            // this.ELEMENT_DATA_FILE[1]['fileExists'] = false

            // this.ELEMENT_DATA_FILE[2]['filename'] = "";
            // this.ELEMENT_DATA_FILE[2]['fileExists'] = false

            // this.ELEMENT_DATA_FILE[3]['filename'] = "";
            // this.ELEMENT_DATA_FILE[3]['fileExists'] = false

            // this.ELEMENT_DATA_FILE[4]['filename'] = "";
            // this.ELEMENT_DATA_FILE[4]['fileExists'] = false

            // this.ELEMENT_DATA_FILE[5]['filename'] = "";
            // this.ELEMENT_DATA_FILE[5]['fileExists'] = false
        //  }
        }

        this.Common_ID = r.Common_ID
        console.log("poi_type", this.poi_type)
        console.log("this.ELEMENT_DATA_FILE ", this.ELEMENT_DATA_FILE)
        if (r.SR_URN != null && r.SR_URN != '')
          this.entityForm.controls['urn_no'].setValue(r.SR_URN);
        else
          this.entityForm.controls['urn_no'].setValue(r.Entity_Ref_No);

        this.modifiedCount = r.Modified_Count

        let rtype
        if (r.Entity_Status == "C" && (r.Entity_ID == "" || r.Entity_ID == null)){
          rtype = "New Registration";
          this.setRejectReasons("NR");
        }
        else
        {
          rtype = "Profile Modification";
          this.setRejectReasons("PM");
        }
        
        if (r.Entity_Status == "C" && r.Modified_Count == "0") {
          this.entityForm.controls['request_type'].setValue(rtype)
        }
        else if (r.Entity_Status == "C" && r.Modified_Count == "1") {
          this.entityForm.controls['request_type'].setValue(rtype + ", Modified Count: 1")
        }
        else if (r.Entity_Status == "C" && r.Modified_Count == "2") {
          this.entityForm.controls['request_type'].setValue(rtype + ", Modified Count: 2")
          this.modifyFlag = true
        }
        else if (r.Entity_Status == "A") {
          this.entityForm.controls['request_type'].setValue("Approved")
          this.approveFlag = true
          this.rejectFlag = true
          this.modifyFlag = true
        }
        else if (r.Entity_Status == "R") {
          this.entityForm.controls['request_type'].setValue("Rejected")
          this.approveFlag = true
          this.rejectFlag = true
          this.modifyFlag = true
        }
        else {
          this.entityForm.controls['request_type'].setValue("");
        }

        //modify disable button for new class registration
        if (r.Entity_ID == "" && r.Previous_Data.Entity_ID != "") {
          this.modifyFlag = true
        }

        //modify disable button for approved entities
        if (r.Entity_ID != "") {
          this.modifyFlag = true
        }

        var newapprovedTS = ''
        var newrejectTS = ''
        if (r.Entity_Status == "A")
          newapprovedTS = r.E_Approve_Date + " " + r.E_Approve_Time

        else if (r.Entity_Status == "R")
          newrejectTS = r.E_Approve_Date + " " + r.E_Approve_Time
        else {
          newrejectTS = "";
          newapprovedTS = " "
        }
        this.entityForm.controls['creation_timestamp'].setValue(moment(r.createdAt).tz('Asia/Kolkata').format('LLL')); // DD-MM-YYYY HH:mm
        this.entityForm.controls['assigned_timestamp'].setValue(moment(r.updatedAt).tz('Asia/Kolkata').format('LLL'));

        if (r.Previous_Data.Entity_ID != r.Entity_ID)
          this.ELEMENT_DATA[0]['existing_details'] = r.Entity_ID;
        if (r.Previous_Data.Entity_Creator != r.Entity_Creator)
          this.ELEMENT_DATA[1]['existing_details'] = (r.Entity_Creator).toUpperCase();

        if (r.Previous_Data.Entity_Registration_For != r.Entity_Registration_For)
          this.ELEMENT_DATA[2]['existing_details'] = r.Entity_Registration_For
        if (r.Entity_TM_Type != "null" && r.Entity_TM_Type != null && r.Previous_Data.Entity_TM_Type != r.Entity_TM_Type)
          this.ELEMENT_DATA[3]['existing_details'] = r.Entity_TM_Type;
        if (r.Previous_Data.POI_Type != r.POI_Type || r.Previous_Data.Entity_Status == "I")
          this.ELEMENT_DATA[4]['existing_details'] = r.POI_Type;

        if (this.Pan(r.Previous_Data.POI) != r.POI || r.Previous_Data.Entity_Status == "I")
          this.ELEMENT_DATA[5]['existing_details'] = r.POI;

        if (r.Previous_Data.Entity_GST_Id != r.Entity_GST_Id)
          this.ELEMENT_DATA[6]['existing_details'] = r.Entity_GST_Id;
        if (r.Previous_Data.Entity_Addr != r.Entity_Addr  )
          this.ELEMENT_DATA[7]['existing_details'] = r.Entity_Addr;
        if (r.Previous_Data.Entity_Addr1 != r.Entity_Addr1)
          this.ELEMENT_DATA[8]['existing_details'] = r.Entity_Addr1;
        if (r.Previous_Data.Entity_Addr2 != r.Entity_Addr2)
          this.ELEMENT_DATA[9]['existing_details'] = r.Entity_Addr2;
        if (r.Previous_Data.Entity_Landmark != r.Entity_Landmark)
          this.ELEMENT_DATA[10]['existing_details'] = r.Entity_Landmark;
        if (r.Previous_Data.Entity_Country != r.Entity_Country && r.Entity_Country != "null")
          this.ELEMENT_DATA[11]['existing_details'] = r.Entity_Country;
        if (r.Previous_Data.Entity_State != r.Entity_State && r.Entity_State != "null")
          this.ELEMENT_DATA[12]['existing_details'] = r.Entity_State;
        if (r.Previous_Data.Entity_City != r.Entity_City && r.Entity_City != "null")
          this.ELEMENT_DATA[13]['existing_details'] = r.Entity_City;
        if (r.Previous_Data.Entity_Pincode != r.Entity_Pincode)
          this.ELEMENT_DATA[14]['existing_details'] = r.Entity_Pincode;
        if (r.Previous_Data.E_Org_Name != r.E_Org_Name )
          this.ELEMENT_DATA[15]['existing_details'] = r.E_Org_Name;
        if (r.Previous_Data.E_Org_Type != r.E_Org_Type || r.Previous_Data.Entity_Status == "I")
          this.ELEMENT_DATA[16]['existing_details'] = varEClass[r.E_Org_Type];

        if (r.Previous_Data.Entity_Industry != r.Entity_Industry) {
          if (r.Entity_Industry == "Others")
            this.ELEMENT_DATA[17]['existing_details'] = "Others -" + r.Entity_Industry_Other;
          else
            this.ELEMENT_DATA[17]['existing_details'] = r.Entity_Industry;
        }

        if (r.Previous_Data.Entity_Sector != r.Entity_Sector) {
          if (r.Entity_Sector == "Others")
            this.ELEMENT_DATA[18]['existing_details'] = "Others -" + r.Entity_Sector_Other;
          else
            this.ELEMENT_DATA[18]['existing_details'] = r.Entity_Sector;
        }

        if (r.Previous_Data.Entity_AuthSignName != r.Entity_AuthSignName)
          this.ELEMENT_DATA[19]['existing_details'] = r.Entity_AuthSignName;
        if (r.Previous_Data.Entity_EmailID != r.Entity_EmailID || r.Previous_Data.Entity_Status == "I")
          this.ELEMENT_DATA[20]['existing_details'] = r.Entity_EmailID;
        if (r.Previous_Data.Entity_Mobile_No != r.Entity_Mobile_No || r.Previous_Data.Entity_Status == "I")
          this.ELEMENT_DATA[21]['existing_details'] = r.Entity_Mobile_No;
        if (r.Entity_Status == "C") {
          this.ELEMENT_DATA[22]['existing_details'] = "Pending For Approval"
        } else if (r.Entity_Status == "R") {
          this.ELEMENT_DATA[22]['existing_details'] = "Pending For Approval"
        } else if (r.Entity_Status == "M1") {
          this.ELEMENT_DATA[22]['existing_details'] = "Sent For Modification, Modified Count: 1"
        } else if (r.Entity_Status == "M2") {
          this.ELEMENT_DATA[22]['existing_details'] = "Sent For Modification, Modified Count: 2"
        } else if (r.Entity_Status == "A") {
          this.ELEMENT_DATA[22]['existing_details'] = "Approved"
        } else {
          this.ELEMENT_DATA[22]['existing_details'] = " "
        }
        if (r.Previous_Data.createdAt != r.createdAt || r.Previous_Data.Entity_Status == "I")
          this.ELEMENT_DATA[23]['existing_details'] = moment(r.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss')
        if(r.Entity_Status!="C")
        this.ELEMENT_DATA[24]['existing_details'] = newapprovedTS //approvedTS
       else
        this.ELEMENT_DATA[24]['existing_details'] = "" //approvedTS
        this.ELEMENT_DATA[25]['existing_details'] = moment(r.updatedAt).tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss')
        this.ELEMENT_DATA[26]['existing_details'] = "Tata" //"Tata"
        this.ELEMENT_DATA[27]['existing_details'] = "False" //"False" 
        if (r.Previous_Data.POA != r.POA)
          this.ELEMENT_DATA[28]['existing_details'] = r.POA;
        if (r.Previous_Data.Other_Doc_Name != r.Other_Doc_Name)
          this.ELEMENT_DATA[29]['existing_details'] = r.Other_Doc_Name;


        if (r.Entity_ID != "" && r.Entity_ID != null) {
          this.ELEMENT_DATA[30]['existing_details'] = "Registered"
        }
        else {
          this.ELEMENT_DATA[30]['existing_details'] = "Not Registered"
        }
        this.ELEMENT_DATA[31]['existing_details'] = newrejectTS
        if (r.E_Mod2_RequestAt != null && r.E_Mod2_RequestAt != undefined)
          this.ELEMENT_DATA[32]['existing_details'] = moment(r.E_Mod2_RequestAt).tz('Asia/Kolkata').format('LLL')
        else
          this.ELEMENT_DATA[32]['existing_details'] = ""

      })
  }


  Pan(datas) {
    const key = '18bcd0b950de300fb873788958fde988fec9b478a936a3061575b16f79977d5b';
    const IV = '2e11075e7b38fa20e192bc7089ccf32b';

    const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Hex.parse(datas) }, CryptoJS.enc.Hex.parse(key), {
      iv: CryptoJS.enc.Hex.parse(IV),
      mode: CryptoJS.mode.CBC
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }


  backClicked() {
    console.log("clickedddddddddddd");
    this._location.back();
  }



  download(file1, filetype) {
    var data = {
      "Entity_Ref_No": this.Common_ID,
      "Folder": filetype,
      "FileName": file1,
      "Entity_Class": this.response.Entity_Class

    }

    this.es.modifyFileDownload(data).subscribe(r => {
      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: 'Entity Verification',
        msg: 'File has been downloaded Successfully'
      });
    })
  }
  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();

  }

  //change status
  makeStatus(status) {
    this.EntityStatus = status
    this.showRemarks = true
    this.showRejectReason = false
    this.showModifyReason = false

    //check if 2nd time modification
    if (this.modifiedCount == "1" && status == "M1") {
      this.EntityStatus = "M2"
    }

    if (status == "R") {
      this.showRejectReason = true
    }
    else if (status == "M1") {
      this.showModifyReason = true
    }
    else {
      this.showRejectReason = false
      this.showModifyReason = false

    }
  }

  isSpecCheckadres: boolean = false;
  noWhitespaceValidator(control) {
    if (control.value.startsWith(' ')) {
      this.isSpecCheckadres = true;
    } else
      if (control.value.endsWith(' ')) {
        this.isSpecCheckadres = true;
      } else {
        this.isSpecCheckadres = false;

      }


  }


  onSubmit() {
    if (this.entityForm.invalid) {
      console.log("invalid");
      this.disableForm = true;
      console.log("form 1 :", this.entityForm);

      let invalid = [];
      let controls = this.entityForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          console.log("name __ ", name);
          invalid.push(name);
        }
      }
      return;

    }

    if (this.isSpecCheckadres) {
      return true;
    }
    console.log("submitting form..");
    this.modalRef = this.modalService.show(ModalPromptEntityComponent)
    this.modalRef.content.modalDataObj = {
      title: "PE/TM/TA Verification",
      //msg: "Your data sumbitted successfully. Would you like to complete registration process now?"
      msg: "Are you sure that you want to submit?",
      btnYes: 'Yes',
      btnNo: 'No'
    }
    this.modalRef.content.onClose.subscribe(result => {
      this.returnedValue = result
      console.log("results", result)

      if (this.returnedValue == true) {

        let apprID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
        // var addressForDLT = this.response.Entity_Addr1+', '+this.response.Entity_Addr2+', '+(this.response.Entity_Landmark!=null &&this.response.Entity_Landmark!='')?this.response.Entity_Landmark+', ':''+this.response.Entity_City+', '+this.response.Entity_State+', '+this.response.Entity_Country+', '+this.response.Entity_Pincode
        var data = {
          Reject_Reason: this.entityForm.get("rej_reason").value,
          Modify_Comment: this.entityForm.get("modification_reason").value,
          Entity_Comment: this.entityForm.get("remarks").value,
          Entity_Status: this.EntityStatus,
          Entity_Ref_No: this.response.Entity_Ref_No,
          E_Org_Type: this.response.E_Org_Type,
          POI: this.response.POI,
          Entity_Name: this.response.E_Org_Name,
          Entity_ID: this.response.Entity_ID,
          Entity_Registration_For: this.response.Entity_Registration_For,
          E_Approve_By: apprID,
          Payment_Applicable: this.entityForm.get("paymen_applicable").value,
          Common_ID: this.Common_ID,
          Entity_Addr: this.response.Entity_Addr,
          Update_After_Approval: this.response.Update_After_Approval
        }
        //updating E_Org_Type to DLT allowed type if Others 
        if (this.response.E_Org_Type == "O1" || this.response.E_Org_Type == "O2" || this.response.E_Org_Type == "O3" || this.response.E_Org_Type == "O4" || this.response.E_Org_Type == "O5" || this.response.E_Org_Type == "O") {
          data.E_Org_Type = "O"
        }

        this.es.updateEntity(data)
          .subscribe(r => {
            console.log("updateEntity response", r)
            if (r.status == "approved") {
              this.$modal.successModal({
                title: 'PE/TM/TA Verification',
                msg: this.response.Entity_Registration_For + " request is approved!"
              });

            }
            else if (r.status == "srApproved") {
              this.$modal.successModal({
                title: 'PE/TM/TA Verification',
                msg: "Service request is approved!"
              });

            }
            else if (r.status == "errDLT") {
              this.$modal.errorModal({
                title: 'PE/TM/TA Verification',
                msg: "Error while updating user in DLT! " + r.err
              })

            } else if (r.status == "errClassification") {
              this.$modal.errorModal({
                title: 'PE/TM/TA Verification',
                msg: "There is some issue with classification!"
              })

            } else if (r.status == "rejected") {
              this.$modal.successModal({
                title: 'PE/TM/TA Verification',
                msg: "User has been Rejected!"
              })

            }
            else if (r.status == "srRejected") {
              this.$modal.successModal({
                title: 'PE/TM/TA Verification',
                msg: "Service Request has been Rejected!"
              })

            }
            else if (r.status == "modified1") {
              this.$modal.successModal({
                title: 'PE/TM/TA Verification',
                msg: "Request has been sent for modification for the first time!"
              })

            } else if (r.status == "modified2") {
              this.$modal.successModal({
                title: 'PE/TM/TA Verification',
                msg: "Request has been sent for modification for the second time!"
              })

            } else if (r.status == "unknownUpdate") {
              this.$modal.errorModal({
                title: 'PE/TM/TA Verification',
                msg: "Some Information is missing"
              })

            } else if (r.status == "fail") {
              this.$modal.errorModal({
                title: 'PE/TM/TA Verification',
                msg: "Failed, Error occurred: " + r.error
              })
            } else { console.log("Response status unknown!") }

            this.router.navigateByUrl('/entity-worklist')
          })
      }
    })
  }
  setRejectReasons(reqType){
    if(reqType=="PM"){
      this.rejectlistitems=[
        { value: 'Incorrect Industry Category selected, pls reinitiate the modification', viewValue: 'Incorrect Industry Category selected, pls reinitiate the modification' },
        { value: 'Documents supporting the correct Industry category has not been attached', viewValue: 'Documents supporting the correct Industry category has not been attached' },
        { value: 'Incorrect New Name entered, pls reinitiate the modification', viewValue: 'Incorrect New Name entered, pls reinitiate the modification' },
        { value: 'Mismatch b/w the New Name entered and documents attached, pls reinitiate the modification', viewValue: 'Mismatch b/w the New Name entered and documents attached, pls reinitiate the modification' },
        { value: 'Valid documents supporting the Name change has not been attached', viewValue: 'Valid documents supporting the Name change has not been attached' },
        { value: 'Mismatch b/w the Address in the request and documents attached, pls reinitiate the modification', viewValue: 'Mismatch b/w the Address in the request and documents attached, pls reinitiate the modification' },
        { value: 'Valid Proof of address has not been uploaded', viewValue: 'Valid Proof of address has not been uploaded' },
        { value: 'Pls attach valid documents to establish relation that New name and existing name are of the same entity', viewValue: 'Pls attach valid documents to establish relation that New name and existing name are of the same entity' },
        { value: 'New Documents supporting the modification have not been uploaded', viewValue: 'New Documents supporting the modification have not been uploaded' },
        { value: 'PIN code mentioned incorrectly/ is invalid', viewValue: 'PIN code mentioned incorrectly/ is invalid' },
        { value: 'SEBI certificate is not attached', viewValue: 'SEBI certificate is not attached' },
        { value: 'GST ID incorrect/ invalid/ not matching with the documents', viewValue: 'GST ID incorrect/ invalid/ not matching with the documents' },
        { value: 'GST certificate has not been uploaded', viewValue: 'GST certificate has not been uploaded' },
        { value: 'Invalid/ Incorrect details entered, pls reinitiate the request', viewValue: 'Invalid/ Incorrect details entered, pls reinitiate the request' },
        { value: 'Documents supporting modification are Invalid/ Incomplete, pls reinitiate the request', viewValue: 'Documents supporting modification are Invalid/ Incomplete, pls reinitiate the request' },
        { value: 'Pls approach your Creator operator to modify NAME as per documents and then raise modification request along with valid supporting documents with us', viewValue: 'Pls approach your Creator operator to modify NAME as per documents and then raise modification request along with valid supporting documents with us' },
        { value: 'Pls get your POI (PAN/TAN) corrected from your Creator operator\'s end and reinitiate the request', viewValue: 'Pls get your POI (PAN/TAN) corrected from your Creator operator\'s end and reinitiate the request' },
        { value: 'Pls get your Industry Category corrected from your Creator operator\'s end and then raise modification request along with valid supporting documents with us', viewValue: 'Pls get your Industry Category corrected from your Creator operator\'s end and then raise modification request along with valid supporting documents with us' },
        { value: 'Invalid Request', viewValue: 'Invalid Request' },
      ]
    }
    else{
      this.rejectlistitems=[
        { value: 'Pls approach your Creator operator to modify NAME as per documents', viewValue: 'Pls approach your Creator operator to modify NAME as per documents' },
        { value: 'Pls get your POI (PAN/TAN) corrected from your Creator operator\'s end and reinitiate the request', viewValue: 'Pls get your POI (PAN/TAN) corrected from your Creator operator\'s end and reinitiate the request' },
        { value: 'Pls get your Industry Category corrected from your Creator operator\'s end and then raise modification request along with valid supporting documents with us', viewValue: 'Pls get your Industry Category corrected from your Creator operator\'s end and then raise modification request along with valid supporting documents with us' },
        { value: 'Pls get your Address corrected from your Creator operator\'s end and then raise modification request along with valid supporting documents with us', viewValue: 'Pls get your Address corrected from your Creator operator\'s end and then raise modification request along with valid supporting documents with us' },
        { value: 'Address on request different from the Address on the documents', viewValue: 'Address on request different from the Address on the documents' },
        { value: 'Documents have not been uploaded properly so could not be validated', viewValue: 'Documents have not been uploaded properly so could not be validated' },
        { value: 'Entity Name entered is different from name on the documents', viewValue: 'Entity Name entered is different from name on the documents' },
        { value: 'GST ID incorrect/ invalid/ not matching with the documents', viewValue: 'GST ID incorrect/ invalid/ not matching with the documents' },
        { value: 'Incorrect  Industry type/ Sector selected', viewValue: 'Incorrect  Industry type/ Sector selected' },
        { value: 'Incorrect Industry Category selected (Govt/ PvtLtd/Public Ltd/ SEBI/ Others)', viewValue: 'Incorrect Industry Category selected (Govt/ PvtLtd/Public Ltd/ SEBI/ Others)' },
        { value: 'Incorrect PAN/ TAN Number entered', viewValue: 'Incorrect PAN/ TAN Number entered' },
        { value: 'Information not entered correctly/ completely in the request', viewValue: 'Information not entered correctly/ completely in the request' },
        { value: 'Insufficient/ Invalid Documents', viewValue: 'Insufficient/ Invalid Documents' },
        { value: 'Invalid / Expired documents uploaded', viewValue: 'Invalid / Expired documents uploaded' },
        { value: 'Invalid Pin Code entered', viewValue: 'Invalid Pin Code entered' },
        { value: 'Mismatch b/w information in the request and documents uploaded', viewValue: 'Mismatch b/w information in the request and documents uploaded' },
        { value: 'PAN/ TAN Document has not been uploaded', viewValue: 'PAN/ TAN Document has not been uploaded' },
        { value: 'Proof of Address document has not been uploaded', viewValue: 'Proof of Address document has not been uploaded' },
        { value: 'Request cannot be raised by Individuals', viewValue: 'Request cannot be raised by Individuals' },
        { value: 'SEBI certificate has not been attached', viewValue: 'SEBI certificate has not been attached' },
        { value: 'Unable to establish connection between PAN/TAN owner and entity', viewValue: 'Unable to establish connection between PAN/TAN owner and entity' },
        { value: 'Documents have not been attached even after modification', viewValue: 'Documents have not been attached even after modification' },
        { value: 'Information in the request not correct even after modification', viewValue: 'Information in the request not correct even after modification' },
        { value: 'Reraise request and enter details of the TRUST', viewValue: 'Reraise request and enter details of the TRUST' }, 
      ]
    }    
  }
}//end of export

export class ExampleDataSource extends DataSource<any> {
  private dataSubject = new BehaviorSubject<Element[]>([])
  data() {
    return this.dataSubject.value;
  }
  update(data) {
    this.dataSubject.next(data);
  }
  constructor(data: any[]) {
    super();
    this.dataSubject.next(data);
  }
  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Element[]> {
    return this.dataSubject;
  }
  disconnect() { }
}